import { ArrowRight } from 'lucide-react';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';

import type { components } from 'wg-api-sdk';

import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import { Button } from '@/components/shadcn/button';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';

type Props = {
  action: components['schemas']['OnesuranceAction'];
};

export default function ActionCallCustomer({ action }: Props) {
  const { t } = useTranslation();
  const party = useSelectedParty();
  const { email } = useEmail();

  const handleClick = () => {
    posthog.capture('Onesurance action clicked', {
      actionType: 'CALL_CUSTOMER',
      order: action.order,
      hasUrl: Boolean(action.url),
      messageId: email?.messageId,
      partyId: party?.id,
    });
  };

  return (
    <Button
      variant={action.order === 1 ? 'default' : 'secondary'}
      size="xs"
      asChild
    >
      <a href={action.url ?? `tel:${party?.telephonenr}`} onClick={handleClick}>
        {action.title ?? t('ONESURANCE_ACTION_CALL_CUSTOMER')}

        <ArrowRight />
      </a>
    </Button>
  );
}
